import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import TextInput from '@deliveroo/consumer-component-library/components/TextInput';

const MAX_LENGTH = 200;

export default class OrderRatingComment extends Component {
  state = {
    showError: false,
    rows: 2,
  };

  onFocus = () => {
    this.setState({ rows: 4 }, () => {
      this.comment.scrollIntoView();
      this.comment.focus();
    });
  };

  onChange = (event) => {
    const text = event.target.value;
    this.props.onChange(text);
    this.setState({ showError: text.length === MAX_LENGTH });
  };

  render() {
    const {
      questionLowRating,
      questionHighRating,
      placeholderLowRating,
      placeholderHighRating,
      characterLimitError,
      ratingComment,
      isLowRatingSelected,
    } = this.props;

    const { showError, rows } = this.state;
    const placeholder = isLowRatingSelected ? placeholderLowRating : placeholderHighRating;

    return (
      <div>
        <Heading level={3} size="x-small" spacing="x-large 0 medium">
          {isLowRatingSelected ? questionLowRating : questionHighRating}
        </Heading>
        <TextInput
          name="order-rating-comment"
          rows={rows}
          maxLength={MAX_LENGTH}
          value={ratingComment}
          placeholder={placeholder}
          isInvalid={showError}
          errorMessage={characterLimitError}
          onChange={this.onChange}
          onFocus={this.onFocus}
          inputRef={(el) => {
            this.comment = el;
          }}
        />
      </div>
    );
  }
}

OrderRatingComment.propTypes = {
  questionLowRating: PropTypes.string.isRequired,
  questionHighRating: PropTypes.string.isRequired,
  placeholderLowRating: PropTypes.string.isRequired,
  placeholderHighRating: PropTypes.string.isRequired,
  characterLimitError: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  ratingComment: PropTypes.string,
  isLowRatingSelected: PropTypes.bool,
};

OrderRatingComment.defaultProps = {
  ratingComment: '',
  isLowRatingSelected: false,
};
